import React from 'react';
import { titleFontSizesBOH } from '../../../helpers/utils';
import './CustomerSatisfactionRates.scss';
import { DateTime } from 'luxon';
import Goal from './Goal';
import BottomBar from '../../../components/BottomBar';
const CustomerSatisfactionRates = ({
  metadata,
  data,
  text
}) => {
  const formatGoals = () => {
    var _metadata$boh_nps;
    const boh_nps = (_metadata$boh_nps = metadata === null || metadata === void 0 ? void 0 : metadata.boh_nps) !== null && _metadata$boh_nps !== void 0 ? _metadata$boh_nps : [];
    const nps = data === null || data === void 0 ? void 0 : data.data;
    return boh_nps.map(metric => ({
      name: metric.replace(/_/g, ' '),
      value: nps === null || nps === void 0 ? void 0 : nps[metric]
    }));
  };
  const accent_color = metadata.accent_color;
  const logo = metadata.logo;
  const timezone = data === null || data === void 0 ? void 0 : data.timezone;
  const hide_poweredbyshift = metadata.hide_poweredbyshift;
  const goals = formatGoals();
  const bodyLastUpdated = ` NPS period-to-date as ${(data === null || data === void 0 ? void 0 : data.last_updated) === null ? 'N/A' : DateTime.fromISO(data === null || data === void 0 ? void 0 : data.last_updated, {
    zone: timezone
  }).toFormat('MM/dd')} at ${(data === null || data === void 0 ? void 0 : data.last_updated) === null ? 'N/A' : DateTime.fromISO(data === null || data === void 0 ? void 0 : data.last_updated, {
    zone: timezone
  }).toFormat('t')}`;
  return /*#__PURE__*/React.createElement("div", {
    className: "customer-satisfaction-rates-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, logo && /*#__PURE__*/React.createElement("img", {
    src: logo,
    className: "logo",
    alt: "logo"
  }), /*#__PURE__*/React.createElement("h1", {
    className: "title",
    style: {
      color: text.title_color,
      fontFamily: text.title_font_family,
      fontSize: titleFontSizesBOH.medium
    }
  }, text.title), /*#__PURE__*/React.createElement("p", {
    className: "updated-time",
    style: {
      color: text.body_color
    }
  }, bodyLastUpdated)), /*#__PURE__*/React.createElement("div", {
    className: "goals-container"
  }, goals.map(g => {
    var _g$name;
    return /*#__PURE__*/React.createElement(Goal, {
      key: g.name,
      value: g === null || g === void 0 ? void 0 : g.value,
      name: (_g$name = g === null || g === void 0 ? void 0 : g.name) !== null && _g$name !== void 0 ? _g$name : '',
      accent_color: accent_color,
      width: `${100 / goals.length - 10}%`,
      fontStyles: {
        color: text.title_color,
        fontFamily: text.title_font_family
      }
    });
  })), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text.accent_color,
    hide_poweredbyshift: hide_poweredbyshift
  }));
};
export default CustomerSatisfactionRates;